export function breakBlocks({ editor, event }) {
  return true;
}
